import { Component, inject } from '@angular/core';
import {VendorsModule} from "../../../../../vendors/src/lib/vendors.module";
import { HttpParams } from '@angular/common/http';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ApiBaseService } from '../../../../../vendors/src/lib/services/api-base.service';
import { AuthApiEnum } from '../../@application/enums/auth-api.enum';
import { AuthPathEnum } from '../../@application/enums/auth-path.enum';

@Component({
    selector: 'lib-forget-password',
    imports: [
        RouterLink,
        VendorsModule,
        ReactiveFormsModule,
        FormsModule
    ],
    templateUrl: './forget-password.component.html',
    styleUrl: './forget-password.component.css'
})
export class ForgetPasswordComponent {
  mobileNumber = new FormControl();
  path = AuthPathEnum
  apiBaseService = inject(ApiBaseService)
  router = inject(Router)

  ngOnInit(): void {
    this.mobileNumber = new FormControl(null, [Validators.required])
  }


  submitForm() {
    this.router.navigate([AuthPathEnum.Forget_Password_Verify])
    if (this.mobileNumber.value !== null && this.mobileNumber.value) {
      const user = this.mobileNumber.value;
      const parms = new HttpParams().append('mobileNumber', user)
      this.apiBaseService.POST_API([AuthApiEnum.Auth,AuthApiEnum.Password, AuthApiEnum.Forget], {},
        true, true,'', parms)
        .subscribe({
          next: value => {
          },
          error: err => {
          }
        })
    }
  }
}
